import styled, { css } from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../constants';

export const Image = ({ imagesArray = [], alt }) => {
  const { layout } = useSettings();
  return (
    <Container _layout={layout}>
      <Img
        src={imagesArray[0] ? imagesArray[0].link : ''}
        srcSet={imagesArray
          .map((item) => `${item.link} ${item.width}w`)
          .join(', ')}
        alt={alt || ''}
        draggable={false}
        onClick={(e) => e.preventDefault()}
      />
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${classnamePrefix}-image-container`
})`
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  user-drag: none;
  user-select: none;

  ${({ _layout }) =>
    _layout !== 'playlist' &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    `}
`;

const Img = styled.img.attrs({
  className: `${classnamePrefix}-image-image`
})`
  max-width: 100%;
  pointer-events: none;
  position: relative;
  width: 100%;
  height: auto;
  user-drag: none;
  user-select: none;
  object-fit: cover;
  transform: scale(1);
  transition: transform 0.3s ease;
`;
